import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import { CookieService } from 'ngx-cookie';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpService } from './http.service';
import { SubjectModelListItem } from '../_objects/subject-model';
import { RtbAuthService } from '../auth/rtb-auth.service';

@Injectable()
export class SubjectModelService extends HttpService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
    private rtbAuthService: RtbAuthService) {
    super(rtbAuthService);
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  // MD01 GET /api/subject/vX/{tenantId}/models
  getSubjectModels(enabledOnly?: boolean): Observable<SubjectModelListItem[]> {
    let httpParams = new HttpParams();
    if (enabledOnly !== null && enabledOnly !== undefined) {
      httpParams = httpParams.set('enabledOnly', String(enabledOnly));
    }

    return this.http.get<SubjectModelListItem[]>('/api/models',
      { headers: this.getTimeZoneHeader(), withCredentials: super.getWithCredentialsOption(), params: httpParams })
      .pipe(map(response => response as SubjectModelListItem[]),
        catchError((error) => {
          this.handleErrorUnauthorized(error);
          throw (error);
        }));
  }
}
